@import "../../variables.scss";

.profile {
  &__findjob {
    position: relative;
    border: 1px solid #E2E8F0;
    background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    &_button {
      @media (max-width: $size-sm) {
        margin-top: 1rem;
        width: 100%;
      }
    }
    &_description {
      width: 70%;
      @media (max-width: $size-sm) {
        width: 100%;
        font-size: 12px;
        line-height: 14px;
      }
    }
    &_person {
      position: absolute;
      right: 0;
      bottom: 0;
      @media (max-width: $size-lg) {
        display: none;
      }
    }
  }
}
